module.exports = __webpack_public_path__ + "img/product-7.fb47f6ae.webp";